import React from "react";
import PropTypes from "prop-types";
import "./toggle_switch.scss";

const ToggleSwitch = ({
    checked,
    onChange,
    disabled,
    loading,
    readOnly,
    informative,
    name,
    id,
    className,
    sizeVariant,
    ariaLabel,
    label,
    labelPosition,
    labelClassName
}) => {
    const isBlocked = disabled || loading || readOnly || informative;
    const isNativeDisabled = disabled || loading;

    const handleClick = event => {
        if (isBlocked || !onChange) {
            return;
        }

        onChange(!checked, event);
    };

    const classes = [
        "toggle-switch",
        `toggle-switch--${sizeVariant}`,
        checked ? "toggle-switch--checked" : "toggle-switch--unchecked",
        disabled ? "toggle-switch--disabled" : "",
        loading ? "toggle-switch--loading" : "",
        readOnly ? "toggle-switch--readonly" : "",
        informative ? "toggle-switch--informative" : "",
        className
    ]
        .filter(Boolean)
        .join(" ");

    const labelNode = label ? (
        <span className={["toggle-switch__label", labelClassName].filter(Boolean).join(" ")}>{label}</span>
    ) : null;

    return (
        <span className="toggle-switch-field">
            {labelPosition === "left" && labelNode}
            <button
                type="button"
                id={id}
                name={name}
                onClick={handleClick}
                disabled={isNativeDisabled}
                role="switch"
                aria-checked={checked}
                aria-readonly={readOnly || informative}
                aria-label={ariaLabel || (checked ? "On" : "Off")}
                className={classes}
            >
                <span className="toggle-switch__knob" />
            </button>
            {labelPosition === "right" && labelNode}
        </span>
    );
};

ToggleSwitch.propTypes = {
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    readOnly: PropTypes.bool,
    informative: PropTypes.bool,
    name: PropTypes.string,
    id: PropTypes.string,
    className: PropTypes.string,
    sizeVariant: PropTypes.oneOf(["sm", "md", "lg"]),
    ariaLabel: PropTypes.string,
    label: PropTypes.node,
    labelPosition: PropTypes.oneOf(["left", "right"]),
    labelClassName: PropTypes.string
};

ToggleSwitch.defaultProps = {
    checked: false,
    onChange: null,
    disabled: false,
    loading: false,
    readOnly: false,
    informative: false,
    name: undefined,
    id: undefined,
    className: "",
    sizeVariant: "md",
    ariaLabel: "",
    label: null,
    labelPosition: "right",
    labelClassName: ""
};

export default ToggleSwitch;
